import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the top on route change, or to the anchor when the URL has a hash.
 * Meant to be mounted once inside the Router.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const timer = window.setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 80);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    // Google Analytics SPA page_view on every route change
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + (hash || ""),
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname, hash]);

  return null;
}
